'use strict'

export default class FilesProjects {
    constructor(
       files=[]
    ) {
        this.files=files
    }

}
